/**
 * Created by anair on 4/19/17.
 */
import 'whatwg-fetch';
import Cookies from 'js-cookie';
import {logMessageToServer} from '../js/loggerService';

let instance = null;
let userId = '';

let fetchUserId = fetch('/session-service/api/v1/session/User',
                        {   credentials: "same-origin",
                            headers: {"XSRF_TOKEN": Cookies.get('XSRF_TOKEN')}
                        }).then(function (response) {
                             return response.json();
                        }).then(function (data) {
                            userId = data.id;
                        }).catch(function(failure) {
                            return "";
                        });

var storeDataInUserPreferences = function (fullyQualifiedPreferenceName, preferenceValue, alreadyPersisted) {
    let dataToPersist = {fullyQualifiedName: fullyQualifiedPreferenceName, value: JSON.stringify(preferenceValue)};
        if(alreadyPersisted) {
            updatePreference(dataToPersist, fullyQualifiedPreferenceName);
        } else {
            createPreference(dataToPersist);
        }
};

let updatePreference = (dataToPersist, fullyQualifiedPreferenceName) => {
    //Make PUT call.
    return fetch("/preference-service/api/v1/Users('" + userId + "')/Preferences('" + fullyQualifiedPreferenceName + "')", {
        method: "put",
        body: JSON.stringify(dataToPersist),
        credentials: "same-origin",
        headers: {
            "Content-Type": "application/json",
            "XSRF_TOKEN": Cookies.get('XSRF_TOKEN')
        }
    }).then(function (response) {
        return response.ok;
    }).then(function (success) {
        if (success) {
            console.log("Preference for the user saved");
            logMessageToServer("INFO", "TRIAL-PREFERENCE-SERVICE", "Preference for the user saved");
        } else {
            console.log("Unable to save the preference for the user");
            logMessageToServer("ERROR", "TRIAL-PREFERENCE-SERVICE", "Unable to save the preference for the user");
        }
        return '';
    }).catch(function (failure) {
        console.log("Unable to save the preference for the user");
        logMessageToServer("ERROR", "TRIAL-PREFERENCE-SERVICE", "Unable to save the preference for the user");
        return '';
    });
};

let createPreference = (dataToPersist) => {
    return fetch("/preference-service/api/v1/Users('" + userId + "')/Preferences", {
        method: "post",
        body: JSON.stringify(dataToPersist),
        credentials: "same-origin",
        headers: {
            "Content-Type": "application/json",
            "XSRF_TOKEN": Cookies.get('XSRF_TOKEN')
        }
    }).then(function (response) {
        return response.ok;
    }).then(function (success) {
        if (success) {
            console.log("Preference for the user saved");
            logMessageToServer("INFO", "TRIAL-PREFERENCE-SERVICE", "Preference for the user saved");
        } else {
            console.log("Unable to save the preference for the user");
            logMessageToServer("ERROR", "TRIAL-PREFERENCE-SERVICE", "Unable to save the preference for the user");
        }
        return '';
    }).catch(function (failure) {
        console.log("Unable to save the preference for the user");
        logMessageToServer("ERROR", "TRIAL-PREFERENCE-SERVICE", "Unable to save the preference for the user");
        return '';
    });
};

var fetchAllUserPreferences = function () {
        return fetch("/preference-service/api/v1/Users('" + userId + "')/Preferences",
            {method: "get",
                credentials: "same-origin",
                headers: {"XSRF_TOKEN": Cookies.get('XSRF_TOKEN')}} )
            .then(function (response) {
                return response.json();
            }).then(function (data) {
                console.log("Fetch All Data Returned = " +data[0]);
                logMessageToServer("INFO","TRIAL-PREFERENCE-SERVICE","Fetch All Data Returned");
                if(data.length == 0) {
                    console.log("No Preferences found");
                    logMessageToServer("INFO","TRIAL-PREFERENCE-SERVICE","No Preferences found");
                    data = null;
                    return data;
                } else {
                    console.log("Fetch All Data Returning first value = " +data[0].value);
                    return data;
                }
            }).catch(function (data) {
                console.log("Unable to get the preference for the user");
                logMessageToServer("ERROR","TRIAL-PREFERENCE-SERVICE","Unable to get the preference for the user");
                return null;
            });
};

var populateDataObject = function (multipleFullyQualifiedPreferenceName, dataValue) {
    let dataObject = {};
    multipleFullyQualifiedPreferenceName.map(function (name) {
        dataObject[name] = null;
    });
    if(dataValue != null) {
        multipleFullyQualifiedPreferenceName.map(function (name) {
            for(var i= 0 ; i < dataValue.length ; i++) {
                if(name === dataValue[i].fullyQualifiedName) {
                    let value = dataValue[i].value;
                    if (value) {
                        dataObject[name] = value;
                    } else {
                        dataObject[name] = null;
                    }
                }
            }

        });
    }
    return dataObject;
};

class PreferenceService {
    constructor() {
        if (!instance) {
            instance = this;
        }
        return instance;
    }

    storeData(name, data, alreadyPersisted) {
        return fetchUserId.then(function () {
            return storeDataInUserPreferences(name, data, alreadyPersisted);
        });
    }

    remove(name) {

    }

    fetchData(fullyQualifiedPreferenceName) {
        let promise = new Promise( function(resolve, reject) {
            fetchUserId.then(function () {
                return fetchAllUserPreferences();
            }).then((responseData) => {
                let dataObject = {};
                if(responseData != null) {
                    let preferenceValue = responseData[fullyQualifiedPreferenceName];
                    if (preferenceValue) {
                        dataObject[fullyQualifiedPreferenceName] = preferenceValue;
                    } else {
                        dataObject[fullyQualifiedPreferenceName] = '';
                    }
                } else {
                    return dataObject;
                }
                console.log("Successfully obtained the preference for the user");
                resolve(dataObject);
            }).catch(function (data) {
                console.log("Unable to get the preference for the user.");
                reject();
            });
        });
        return promise;
    }

    fetchMultipleData(multipleFullyQualifiedPreferenceName) {
        let promise = new Promise( function(resolve, reject) {
            fetchUserId.then(function () {
                return fetchAllUserPreferences();
            }).then((responseData) => {
                let dataObject = populateDataObject(multipleFullyQualifiedPreferenceName, responseData);
                console.log("Successfully obtained multiple the preference for the user");
                resolve(dataObject);
            }).catch(function (data) {
                console.log("Unable to get the preference for the user.");
                let dataObject = populateDataObject(multipleFullyQualifiedPreferenceName, null);
                reject(dataObject);
            });
        });
        return promise;
    }
}
export default PreferenceService;